
module.exports = function (md) {
  md.core.ruler.push('remove_headers', function removeHeaderAttrs(state) {
    const tokens = [];
    let inHeading = false;

    for (let i = 0; i < state.tokens.length; i++) {
      const token = state.tokens[i];

      if (token.type === 'heading_open') {
        inHeading = true;
      }

      if (!inHeading) {
        tokens.push(token);
      }

      if (token.type === 'heading_close') {
        inHeading = false;
      }
    }

    state.tokens = tokens;
  });
};
